import { useEffect, useState } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
// @mui
// import { Button, IconButton } from '@mui/material';
import { Container, Typography, Stack, Button, Grid, TextField, IconButton } from '@mui/material';



// components
import { showSnackbar } from '../../components/Notification/Snackbar';
// Helpers
import SVGIcons from '../../assets/images/icons/svgIcons';

import FileUploader from '../../components/AwsS3ImageUploader/file.uploader';
import './index.scss';
import ApiCaller from '../../services/api/general';

import BackArrow from '../../assets/images/BackArrow.svg';
import edit from '../../assets/images/edit.svg';
import S3ImageViewerWithFallback from '../../components/awsS3ImageViewer/ImgViewerWithFallback';

// ........................................................................




const AddEditOffPlan = () => {
    const { id = '', page = 'add' } = useParams();
    const navigate = useNavigate();
    const apiCaller = new ApiCaller('off-plan');
    const [isSubmitting, setIsSubmitting] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isTouched, setIsTouched] = useState(false);
    const [isEditEnabled, setIsEditEnabled] = useState(id === undefined || ['add', 'edit'].includes(page));

    // const [isRealEstate, setIsRealEstate] = useState(false);

    const [formData, setFormData] = useState({
        title: '',
        imageURL: '',
    });

    /**
   * sets the form data 
   * @param {string} name the name of the field
   * @param {string} value  the value of the field
   */
    const setFormValue = (name, value) => {
        const formDataAs = { ...formData };
        setFormData({ ...formDataAs, ...{ [name]: value } });
        return true;
    }


    /**
 the legendary use effect function
 This will run very first on render
  */
    useEffect(() => {
        if (id) {
            getData()
        }
        return () => {
            setFormData({})
        };
        // eslint-disable-next-line
    }, []);

    // get users from api
    const getData = () => {
        setIsLoading(true);
        apiCaller.getData(id)
            .then((data) => {
                if (data) {
                    setFormData(data)
                }
            })
            .catch(() => showSnackbar().failure('Something went wrong'))
            .finally(() => setIsLoading(false));
    }


    /**
     * Validates the form and returns true if valid
     * @returns boolean
     */
    const isValidForm = () => {
        let isValid = false;
        if (formData.title) {
            isValid = true;
        }
        return isValid;
    }

    /**
     * On submit the form
     */
    const onSubmit = (refreshData = false) => {

        setIsTouched(true);
        if (isValidForm()) {
            const postData = {
                title: formData.title,
                imageURL: formData.imageURL
            }
            // Submitting data to backend for registration
            setIsSubmitting(true);
            let message = "Property created successfully";
            let action = saveData;
            if (id) {
                action = updateData;
                message = 'Property updated successfully!';
            }
            action(postData).then((data) => {
                if (data.success) {
                    showSnackbar().success(message);
                    navigate(-1)
                } else {
                    showSnackbar().failure(data.message)
                }
            }).finally(() => {
                setIsSubmitting(false);
                if (id && refreshData) {
                    getData()
                }
            });
        }
    };

    /**
     * Saves a Property
     */
    const saveData = (postData) => apiCaller.postData(postData);

    /**
     * Updates a data using its id
     */
    const updateData = (postData) => apiCaller.customPatchData(id, postData);



    return (
        <>
            <Container style={{ paddingTop: '30px', maxWidth: '100%' }}>
                {!isLoading ?
                    <div className='list-main-wrp addEditNews f-wrp' style={{ paddingTop: '10px' }}>
                        <div className="breadcrumb f-wrp">
                            <Link to={"/off-plan"}><img src={BackArrow} alt="back-arrow" />back</Link>
                        </div>
                        <div className='title-head f-wrp'>
                            <div className='title-sec'>

                                <Typography variant="h4" gutterBottom>{(id && isEditEnabled) ? 'Edit Property' : id ? 'View Property' : 'New Property'}</Typography>
                            </div>
                            {id ? <div className='button-sec'>
                                <Button onClick={() => setIsEditEnabled((prv) => !prv)} className={`cancel`} >{isEditEnabled ? 'Cancel' : 'Edit'}</Button> &nbsp;
                            </div> : null}

                        </div>
                        <div className='singleImageUpload f-wrp'>
                            <>
                                <div className='image-uploader'>
                                    <h3>*Images</h3>
                                    {isEditEnabled ? <FileUploader
                                        acceptOnly='image/*'
                                        // uploadIcon={uploadBtn2}
                                        uploadCaption={''}
                                        onUploadEnd={(file) => setFormValue('imageURL', file.fileKey)}
                                    /> : null}
                                    {(formData?.imageURL) ? <span className='uploaded-img'>
                                        {isEditEnabled ? <IconButton children={<SVGIcons.CloseCrossIcon />} onClick={() => setFormValue('imageURL', '')} /> : null}
                                        <S3ImageViewerWithFallback fileKey={formData.imageURL} />
                                    </span> : null}
                                </div>
                            </>
                        </div>

                        <div className='info-sec-wrp f-wrp'>
                            <div className='general-info-sec f-wrp'>
                                <div className='info-head f-wrp'>
                                    <span>General info:</span>
                                    <Button className='edit-btn'><img src={edit} alt="edit" /></Button>
                                </div>

                                <Grid container spacing={3}>
                                    <Grid item xs={12} sm={12} md={6}>
                                        <Stack className='login-form profile-form' spacing={3}>
                                            <TextField
                                                focused
                                                disabled={!isEditEnabled}
                                                id="bulletin_create_form_question_title"
                                                name="title"
                                                label="*Title:"
                                                placeholder='Type here'
                                                type="text"
                                                helperText={!id && isTouched && !formData.title ? 'Title is required' : ''}
                                                error={isTouched && !formData.title}
                                                value={formData?.title}
                                                onChange={(e) => setFormValue('title', e.target.value)}
                                            />

                                        </Stack>
                                    </Grid>
                                </Grid>
                            </div>
                        </div>

                        <div className='button-sec f-wrp'>
                            <Button onClick={() => navigate('/off-plan')} className='cancel'>Cancel</Button> &nbsp;
                            <Button onClick={() => onSubmit('published')} isLoading={isSubmitting} className='fill-btn'>Publish</Button>
                        </div>
                    </div> : <span className='page-loader'>{SVGIcons.LoaderIcon()}</span>}

            </Container>
        </>
    );
}

AddEditOffPlan.propTypes = {}

export default AddEditOffPlan;